import React, { Component } from 'react'; 
import _ from 'lodash';
import Template from './Template';
import ModalWindow from './ModalWindow'
import IndexAuditForm from './indexAudiForm'

class AuditForm extends Component {
  constructor(props){
    super(props)
    this.state ={
      showModal:false,
      templateName:''
    }
  }
  templateisCalled = (obj, obj2) =>{
    if(obj2  === 'view'){
      this.setState({isview:true})
    }
    this.setState({showModal:true, templateName:obj})    
  }
  closeModal = () => {
    this.setState({showModal:false})
  }
  closeModalView = () => {
    this.closeModal()
    this.setState({isview:false})
  }
  render() {    
     const{templatepayload} = _.cloneDeep(this.props)
     const{showModal, templateName, isview} = this.state
    let defaultTemp ;
    let template
    if(!_.isEmpty(templatepayload)){
       defaultTemp = templatepayload.filter(obj => obj.templateName === 'Default Template')      
       template = templatepayload.filter(obj => obj.templateName === templateName) 
    }

    
      return(
        <div>
          {(isview === true && showModal === true) ? 
            <ModalWindow formread={true}
            isview={true} 
            dataList={this.props.payload}
            auditorJson={_.cloneDeep(template[0])}  
            closeModal={()=>this.closeModalView()}/>  
          : 
          (showModal === true) ? 
          (templateName  === 'defaultTemplate') ?      
          <Template templateName={'Default Template'} closeModal={this.closeModal} 
            function={this.props.function} dataList={this.props.payload} nameList={this.props.nameList}
            templatepayload={defaultTemp[0]}/> : 
          <Template edit={true} nameList={this.props.nameList}
          closeModal={this.closeModal} function={this.props.function} dataList={this.props.payload}
          templatepayload={template[0]}/>
          :<IndexAuditForm props = {this.props} onCallBack={this.templateisCalled}/>}
        </div>      
      )
    }
  
}

export default AuditForm;